<template>
  <div>
    <Modal v-model="isShow" :mask-closable="false" @on-ok="ok" @on-cancel="cancel"
           :width="650"
    >
      <h3 slot="header" class="modal-header">查看发票</h3>
      <div class="specialdrop " v-if="formData" >
        <Form :label-width="120" ref="formData" >
          <div >
            <FormItem label="发票类型"  >
              {{formData.invoiceTypeName}}
            </FormItem>
            <FormItem label="费用类型"  >
              {{formData.feeTypeName}}
            </FormItem>

            <FormItem label="开票月份"  >
              <span
                v-for="(item,index) in monthList" :key="'keyL'+index"
                :class="['ivu-btn','btn-primary2','item']">{{item}}</span>
            </FormItem>
            <FormItem label="开票金额"  >
              {{formData.invoiceAmount}}
            </FormItem>
            <FormItem label="开票备注"  >
              <Input class="width250" type="textarea" v-model="formData.remark"  disabled/>
            </FormItem>
          </div>
          <FormItem label="项目名称" >
            <Input class="width250" v-model="formData.projectName" disabled/>
          </FormItem>
          <FormItem label="合同号" >
            <Input class="width250" v-model="formData.conRentCode"  disabled/>
          </FormItem>
          <FormItem label="发票抬头" >
            <Input class="width250" v-model="formData.invoiceTitle" disabled/>
          </FormItem>
          <FormItem label="纳税人识别号" v-if="formData.custTaxNo" >
            <Input class="width250" v-model="formData.custTaxNo" disabled />
          </FormItem>

          <FormItem label="收件人" v-if="formData.invoiceType !==3">
            <Input class="width250" v-model="formData.receiver" disabled/>
          </FormItem>
          <FormItem label="邮寄电话" v-if="formData.invoiceType !==3">
            <Input class="width250" v-model="formData.recPhone" disabled/>
          </FormItem>
          <FormItem label="邮寄地址" v-if="formData.invoiceType !==3">
            <Input class="width250" v-model="formData.recAddress" disabled/>
          </FormItem>
          <FormItem label="邮箱" v-if="formData.invoiceType ===3">
            <Input class="width250" v-model="formData.recEmail" disabled/>
          </FormItem>
          <div v-if="formData.invoiceType===2">
            <FormItem label="专票电话" >
              <Input class="width250" v-model="formData.invoiceCompetencyVo.phone" disabled/>
            </FormItem>
            <FormItem label="专票地址" >
              <Input class="width250" v-model="formData.invoiceCompetencyVo.address" disabled/>
            </FormItem>
            <FormItem label="开户行" >
              <Input class="width250" v-model="formData.invoiceCompetencyVo.bank" disabled/>
            </FormItem>
            <FormItem label="开户行号" >
              <Input class="width250" v-model="formData.invoiceCompetencyVo.bankNum" disabled/>
            </FormItem>

          </div>

        </Form>
      </div>
    </Modal>
  </div>
</template>
<script>
  import {getInvoiceInfoByFid} from "../../../../api/invoice";

  export default {
    name: "",
    components: {},
    props: {
      n: {
        type: Number,
        default: 0
      },
      invoiceFid:{
        type:String,
        default:''
      }
    },
    watch: {
      n() {
        this.formData=null
        this.getInvoiceInfoByFid()
        this.isShow = true
      },

    },
    computed:{
      monthList(){
        if(!this.formData){
          return []
        }
       return this.formData.invoiceMonth.split(',')
      }

    },
    data() {
      return {
        flag1: false,
        flag2: false,
        projectList: [],
        formData: null,
        ZJCouldInvoiceAmount: '',//房租可开票金额
        FWCouldInvoiceAmount: '',
        loading: true,
        isShow: false,
      }
    },
    methods: {
      getInvoiceInfoByFid(){
        if(!this.invoiceFid){
          return
        }
        let params={
          invoiceFid:this.invoiceFid
        }
        getInvoiceInfoByFid(params).then(res=>{
          this.formData=res.data
          this.formData.invoiceAmount&&(this.formData.invoiceAmount=(this.formData.invoiceAmount/100).toFixed(2))
        }).catch(error=>{})
      },
      changeLoading() {
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true
        })
      },
      ok() {},
      cancel() {}
    },
  }
</script>

<style scoped>

  .width250 {
    width: 300px;
  }
  .item{
    margin-right: 10px;
    margin-bottom: 10px;
    width: 100px;
  }





</style>
